import { create } from "zustand";

export interface IRouteOnMapStoreActions {
    setOpen: (open: boolean) => void;
    toggleOpen: () => void;
}

export interface IRouteOnMapStoreState {
    actions: IRouteOnMapStoreActions;
    open: boolean;
}

const useRouteOnMapStore = create<IRouteOnMapStoreState>( (set) => ({
    open: true,
    actions: {
        setOpen: (open: boolean) => {
            set({open: open});
        },
        toggleOpen: () => {
            set((state) => ({open: !state.open}));
        }
    }
}));

export const useRouteOnMapStoreState = () => useRouteOnMapStore((state) => state.open);
export const useRouteOnMapStoreActions = () => useRouteOnMapStore((state) => state.actions);